<script setup>
// @ts-check

import { submitPayslipInput } from '@/api/payslipInputs'
import CardDialog from '@/components/dialogs/CardDialog.vue'
import { useToasts } from '@/core/composables/useToasts'
import { isAxiosError } from 'axios'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  payslipInputId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['close', 'approved', 'error'])

defineOptions({
  name: 'SalaryApprovalDialog'
})

const { t, te, tm } = useI18n()
const { addSuccessToast, addDangerToast } = useToasts()

const isApproving = ref(false)

const approveSalary = async () => {
  try {
    isApproving.value = true
    await submitPayslipInput(props.payslipInputId)
    addSuccessToast({ content: t('salary.success.approval') })
    emit('approved')
  } catch (error) {
    const apiError = isAxiosError(error) ? error.response?.data?.message : null

    const errorMessage = te(`salary.errors.messages.${apiError}`)
      ? t(`salary.errors.messages.${apiError}`)
      : t('salary.errors.approval')

    addDangerToast({ content: errorMessage })
    console.error(error)
    emit('error')
  } finally {
    isApproving.value = false
    emit('close')
  }
}
</script>

<template>
  <CardDialog
    :loading="isApproving"
    :title="t('salary.headings.approval')"
    @action="approveSalary"
    @close="emit('close')"
  >
    <p>
      {{ t('salary.info.approval') }}
    </p>

    <ul class="ml-section flex list-disc flex-col gap-controls">
      <li
        v-for="(bullet, key) in tm('salary.approval.bullets')"
        :key
        class="last:font-semibold"
      >
        {{ bullet }}
      </li>
    </ul>

    <p>
      {{ t('salary.info.approval_postscript') }}
    </p>

    <template #action>
      {{ t('general.approve') }}
    </template>
  </CardDialog>
</template>
